import React from 'react';
import styled from 'styled-components';

import { Switch, Dropdown } from 'components'

const defaultStyle = {
    maxWidth: null,
    borderColor: 'var(--primary-accent-color)',
    borderWidth: '2px'
}

const Container = styled.div`
    padding: 1rem;
    border-width: ${props => props.styles.borderWidth};
    border-style: solid;
    border-color: ${props => props.styles.borderColor};
    /* border: 1px solid var(--primary-accent-color); */
    border-radius: ${props => props.borderRadius};
    cursor: ${props => props.cursor};

    display: flex;
    flex-direction: column;
    max-width: ${props => props.styles.maxWidth};

    /* display: grid;
    grid-template-columns: 10rem 1fr;
    grid-template-rows: auto auto;
    grid-gap: 0.5rem;
    @media (max-width: 600px) {
        display: flex;
        flex-direction: column;
    } */
`

const Title = styled.div`
    grid-column: 1;
    grid-row: 1 / span 2;
    font-weight: bolder;
    font-size: 0.9rem;
    margin-bottom: 0.2rem;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
`

const Row = props => {
    const {
        title,
        value,
        subtitle,
        onSelect,
        borderRadius,
        selector,
        styles
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)

    return (
        <Container onClick={onSelect} borderRadius={borderRadius} cursor={selector ? 'auto' : 'pointer'} styles={updatedStyle}>
            <Title>{title}</Title>
            {selector || <Switch checked={value}/>}
            <Subtitle>{subtitle}</Subtitle>
        </Container>
    )
}

export default Row;